type TimeSlotItemResource = {
  readonly created?: string;
  datetime: string;
  local_datetime: string;
  places_left: number;
  slot_id: number;
  timezone: string;
  tour_id: number;
  readonly updated?: string;
  readonly url?: string;
};

export const getDates = (timeSlotItems: TimeSlotItemResource[] | undefined) => {
  if (!timeSlotItems) return [];

  const filteredDates = timeSlotItems?.map(
    (
      { local_datetime: localDatetime }: TimeSlotItemResource // eslint-disable-line camelcase
    ) => new Date(localDatetime)
  );

  return [...filteredDates];
};

export const getTimesForEachDate = (
  timeSlotItems: TimeSlotItemResource[],
  formatTime: (date: Date) => string,
  formatDate: (date: Date, options: any) => string
) => {
  if (!timeSlotItems) return [];
  const filteredDates = timeSlotItems.reduce(
    (
      acc: any,
      { local_datetime: localDatetime, slot_id: slotId }: TimeSlotItemResource // eslint-disable-line camelcase
    ) => {
      const dateTimeObject = new Date(localDatetime);
      const time = formatTime(dateTimeObject);
      const date = formatDate(dateTimeObject, {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
      });

      acc[date] = acc[date] || [];
      acc[date].push({
        label: time,
        slotId,
      });

      return acc;
    },
    {}
  );

  return filteredDates;
};
